<template>
    <vBudgetReportComponent v-if="flag" :postList="postList"></vBudgetReportComponent>
</template>
<script>
import vBudgetReportComponent from '../../listComponent/budget/budgetReport/reportListComponent.vue';
export default {
    name: 'budgetReportList',
    components: {
        vBudgetReportComponent
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                mk_report_id: true,
                name: true,
                remark: true,
                entity_rid: true,
                reim_person_rid: true,
                cover_person_rid: true,
                supplier_rid: true,
                addBtn: true,
                updateBtn:true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            }
        };
    },

    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>